/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderBerg_isset = SliderBerg_isset;
exports.SliderBerg_mapOrder = SliderBerg_mapOrder;
exports.SliderBerg_Color = SliderBerg_Color;
exports.SliderBerg_GoogleFontLoader = SliderBerg_GoogleFontLoader;
function SliderBerg_isset(arr, var_args) {
  for (var i = 1, k = arguments.length; i < k; ++i) {
    if (!arr || !arr.hasOwnProperty(arguments[i])) return false;
    arr = arr[arguments[i]];
  }
  return true;
}

function SliderBerg_mapOrder(array, order, key) {
  array.sort(function (a, b) {
    var A = a[key],
        B = b[key];

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1;
    } else {
      return -1;
    }
  });

  return array;
}

function SliderBerg_Color() {
  var number_of_color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 999;

  var original_colors = [{ name: 'WHITE', hex: '#ffffff' }, { name: 'BLACK', hex: '#000' }, { name: 'WISTERIA', hex: '#8e44ad' }, { name: 'NEPHRITIS', hex: '#27ae60' }, { name: 'SUN FLOWER', hex: '#f1c40f' }, { name: 'CARROT', hex: '#e67e22' }, { name: 'ALIZARIN', hex: '#e74c3c' }, { name: 'CLOUDS', hex: '#ecf0f1' }, { name: 'CONCRETE', hex: '#95a5a6' }, { name: 'ORANGE', hex: '#f39c12' }, { name: 'PUMPKIN', hex: '#d35400' }, { name: 'POMEGRANATE', hex: '#c0392b' }, { name: 'SILVER', hex: '#bdc3c7' }, { name: 'ASBESTOS', hex: '#7f8c8d' }, { name: 'TURQUOISE', hex: '#1abc9c' }, { name: 'EMERALD', hex: '#2ecc71' }, { name: 'PETER RIVER', hex: '#3498db' }, { name: 'AMETHYST', hex: '#9b59b6' }, { name: 'WET ASPHALT', hex: '#34495e' }, { name: 'GREEN SEA', hex: '#16a085' }, { name: 'BELIZE HOLE', hex: '#2980b9' }, { name: 'MIDNIGHT BLUE', hex: '#2c3e50' }];

  var return_colors = [];
  original_colors.forEach(function (color) {
    return_colors.push({
      name: color.name,
      color: color.hex,
      slug: color.name.toLowerCase()
    });
  });

  if (number_of_color < 999) {
    return return_colors.slice(0, number_of_color);
  }

  return return_colors;
}

function SliderBerg_GoogleFontLoader(font) {
  var fetchStyle = function fetchStyle(url) {
    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.onload = function () {
        resolve();
      };
      link.href = url;

      var headScript = document.querySelector('script');
      headScript.parentNode.insertBefore(link, headScript);
    });
  };

  if (font == 'Theme Default') return false;
  if (font == 'Arial') return false;

  if (!SliderBerg.google_fonts.includes(font)) {
    fetchStyle('https://fonts.googleapis.com/css?family=' + font.replace(' ', '+'));
    SliderBerg.google_fonts.push(font);
  }
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderBerg_Slider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _wp$element = wp.element,
    Component = _wp$element.Component,
    render = _wp$element.render,
    findDOMNode = _wp$element.findDOMNode,
    Fragment = _wp$element.Fragment;


var alias = 'SliderBerg-Slider-';

var SliderBerg_Slider = function (_Component) {
  _inherits(SliderBerg_Slider, _Component);

  function SliderBerg_Slider(props) {
    _classCallCheck(this, SliderBerg_Slider);

    var _this = _possibleConstructorReturn(this, (SliderBerg_Slider.__proto__ || Object.getPrototypeOf(SliderBerg_Slider)).call(this, props));

    _this.state = {
      selected: false,
      elapsed_time: 0,
      isPaused: false,
      displayText: ''
    };

    var items = _this.props.items;

    if (items.length > 0) {
      _this.state.selected = items[0];
    }

    if ((0, _utils.SliderBerg_isset)(_this.props.options, 'autoplay') && !_this.props.options.autoplay) {
      _this.state.isPaused = true;
    }

    if (!(0, _utils.SliderBerg_isset)(_this.props.options, 'slider_height')) {
      _this.props.options = 350;
    }

    _this.mainInterval = null;
    return _this;
  }

  _createClass(SliderBerg_Slider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var interval = 10;

      var scale = 1;
      var scale_step = 0.001;

      this.mainInterval = setInterval(function () {

        if (!_this2.state.isPaused) {
          scale_step = 10 / _this2.props.options.slide_timeout;

          if (_this2.state.elapsed_time >= _this2.props.options.slide_timeout) {
            _this2.goToSlide();
            scale = 1;
          }

          scale = scale + scale_step;

          _this2.setState({
            elapsed_time: _this2.state.elapsed_time + interval
          });

          _this2.refs.current_image.style.transform = 'scale(' + scale + ')';
        }
      }, interval);
    }

    // onMouseOver(e) {
    //   if (this.props.options.autostop) this.setState({ isPaused: true });
    // }

    // onMouseOut(e) {
    //   if (this.props.options.autostop) this.setState({ isPaused: false });
    // }

  }, {
    key: 'buildSliderItems',
    value: function buildSliderItems() {
      var _this3 = this;

      var items = this.props.items;
      var _props$options = this.props.options,
          text_align = _props$options.text_align,
          show_text = _props$options.show_text,
          text_size = _props$options.text_size,
          text_font = _props$options.text_font,
          pag_color = _props$options.pag_color;
      var selected = this.state.selected;


      var textStyle = {};
      if (text_align === 'left') {
        textStyle = {
          left: '40px',
          backgroundColor: this.props.options.text_bg_color
        };
      } else if (text_align === 'right') {
        textStyle = {
          right: '80px',
          position: 'absolute',
          backgroundColor: this.props.options.text_bg_color
        };
      } else if (text_align === 'center') {
        textStyle = {
          left: '50%',
          transform: 'translate(-50%, 0%)',
          backgroundColor: this.props.options.text_bg_color
        };
      }

      var textStyleCustom = {};
      if (text_align === 'left') {
        textStyleCustom = {
          left: '40px'

        };
      } else if (text_align === 'right') {
        textStyleCustom = {
          right: '40px',
          left: 'auto',
          position: 'absolute'

        };
      } else if (text_align === 'center') {
        textStyleCustom = {
          left: '47%',
          transform: 'translate(-47%, 0%)'
        };
      }

      return items.map(function (object_key, index) {
        var item = items[index];
        return React.createElement(
          'li',
          {
            key: index,
            style: {
              zIndex: selected == object_key ? 88 : 1
            }
          },
          React.createElement(
            'a',
            { href: item.url, className: alias + 'main-image' },
            React.createElement('img', {
              ref: selected == object_key ? 'current_image' : '',
              src: item.image.replace(':5360', ''),
              style: {
                //transform: `${selected == object_key ? 'scale(1.8)' : 'scale(1)'}`,
                //transition: `transform 1ms cubic-bezier(0.420, 0.000, 1.000, 1.000)`
              }
            })
          ),
          show_text ? React.createElement(
            Fragment,
            null,
            React.createElement(
              'div',
              { className: 'slider-pagination' },
              React.createElement(
                'h2',
                { style: textStyle },
                React.createElement(
                  'a',
                  { className: 'first',
                    href: item.url,
                    style: {
                      fontSize: text_size + 'px',
                      color: _this3.props.options.text_color,
                      fontFamily: text_font,
                      lineHeight: text_size + 'px'
                    }
                  },
                  item.title
                )
              ),
              React.createElement(
                'p',
                { style: textStyleCustom },
                React.createElement(
                  'a',
                  { className: 'second',
                    style: {
                      backgroundColor: '#000',
                      color: '#fff',
                      lineHeight: text_size + 'px',
                      fontSize: text_size + 'px'
                    }
                  },
                  index + 1 + '/' + items.length
                )
              )
            )
          ) : ''
        );
      });
    }
  }, {
    key: 'goToSlide',
    value: function goToSlide() {
      var where = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'next';
      var items = this.props.items;
      var selected = this.state.selected;


      var current_index = items.indexOf(selected);
      var next_index = -1;

      if (where == 'next') {
        next_index = current_index + 1;
        if (current_index >= items.length - 1) {
          next_index = 0;
        }
      } else if (where == 'prev') {
        next_index = current_index - 1;
        if (current_index <= 0) {
          next_index = items.length - 1;
        }
      }
      this.setState({
        selected: items[next_index],
        elapsed_time: 0
      });
    }
  }, {
    key: 'buildNav',
    value: function buildNav() {
      var _this4 = this;

      var isPaused = this.state.isPaused;


      return React.createElement(
        'div',
        { className: alias + 'nav' },
        React.createElement(
          'a',
          {
            href: '#',
            onClick: function onClick(e) {
              e.preventDefault();
              _this4.goToSlide('prev');
            }
          },
          React.createElement('span', { 'class': 'dashicons dashicons-arrow-left-alt2' })
        ),
        React.createElement(
          'a',
          {
            href: '#',
            onClick: function onClick(e) {
              e.preventDefault();
              _this4.setState({ isPaused: !_this4.state.isPaused });
            }
          },
          isPaused ? React.createElement('span', { 'class': 'dashicons dashicons-controls-play' }) : '',
          !isPaused ? React.createElement('span', { 'class': 'dashicons dashicons-controls-pause' }) : ''
        ),
        React.createElement(
          'a',
          {
            href: '#',
            onClick: function onClick(e) {
              e.preventDefault();
              _this4.goToSlide('next');
            }
          },
          React.createElement('span', { 'class': 'dashicons dashicons-arrow-right-alt2' })
        )
      );
    }
  }, {
    key: 'buildNextTimer',
    value: function buildNextTimer() {
      var pag_color = this.props.options.pag_color;

      var marker_width = this.state.elapsed_time * 100 / this.props.options.slide_timeout;
      return React.createElement('span', {
        className: alias + 'timer',
        style: {
          width: marker_width + '%',
          backgroundColor: pag_color
        }
      });
    }
  }, {
    key: 'buildPag',
    value: function buildPag() {
      var _this5 = this;

      var selected = this.state.selected;
      var items = this.props.items;
      var pag_bg_color = this.props.options.pag_bg_color;


      return React.createElement(
        'div',
        {
          className: alias + 'pag',
          style: {
            gridTemplateColumns: 'repeat(' + items.length + ', 1fr)'
          }
        },
        items.map(function (object_key, index) {
          return React.createElement(
            'div',
            {
              style: {
                backgroundColor: pag_bg_color
              },
              onClick: function onClick() {
                return _this5.setState({ selected: object_key, elapsed_time: 0 });
              }
            },
            object_key == selected ? _this5.buildNextTimer() : ''
          );
        })
      );
    }
  }, {
    key: 'buildMainText',
    value: function buildMainText() {
      var _this6 = this;

      var items = this.props.items;
      var selected = this.state.selected;
      var main_text_size = this.props.options.main_text_size;


      return React.createElement(
        'div',
        { className: alias + 'main-text' },
        items.map(function (item, index) {
          return React.createElement(
            Fragment,
            null,
            React.createElement(
              'h3',
              {
                style: {
                  zIndex: selected == item ? 88 : 1,
                  display: selected == item ? 'block' : 'none',
                  backgroundColor: _this6.props.options.text_bg_color,
                  borderLeftColor: _this6.props.options.pag_bg_color,
                  lineHeight: main_text_size + 'px'
                }
              },
              React.createElement(
                'a',
                {
                  href: item.url,
                  style: {
                    color: _this6.props.options.text_color,
                    fontFamily: _this6.props.options.text_font,
                    fontSize: main_text_size + 'px'
                  }
                },
                item.mainText
              )
            ),
            React.createElement(
              'h5',
              {
                style: {
                  zIndex: selected == item ? 88 : 1
                },
                className: alias + 'read-more'
              },
              React.createElement(
                'a',
                {
                  href: item.url,
                  style: {
                    fontFamily: _this6.props.options.text_font

                  }
                },
                'Read More'
              )
            )
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var items = this.props.items;
      var _props$options2 = this.props.options,
          show_nav = _props$options2.show_nav,
          show_pag = _props$options2.show_pag,
          slider_height = _props$options2.slider_height,
          show_text = _props$options2.show_text;


      return React.createElement(
        'div',
        {
          className: alias + 'wrapper',
          style: {
            height: parseInt(slider_height) + 'px'
          }
          // onMouseOver={this.onMouseOver.bind(this)}
          // onMouseOut={this.onMouseOut.bind(this)}
        },
        React.createElement(
          'ul',
          null,
          items.length ? React.createElement(
            Fragment,
            null,
            show_nav ? this.buildNav() : '',
            show_pag ? this.buildPag() : '',
            this.buildSliderItems()
          ) : ''
        ),
        React.createElement(
          'div',
          { className: alias + 'text-area' },
          show_text ? this.buildMainText() : ''
        )
      );
    }
  }]);

  return SliderBerg_Slider;
}(Component);

exports.SliderBerg_Slider = SliderBerg_Slider;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(3)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(4);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(11);
module.exports = __webpack_require__(12);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var _slider = __webpack_require__(1);

var _utils = __webpack_require__(0);

var _wp$element = wp.element,
    Component = _wp$element.Component,
    render = _wp$element.render;


// Instantiate for every carousel on page
document.addEventListener('DOMContentLoaded', function (event) {
  var sliders = document.querySelectorAll('.SliderBerg-wrapper');
  for (var i = 0; i < sliders.length; i++) {
    var attributes = JSON.parse(sliders[i].getAttribute('data-attributes'));
    console.log(attributes);
    var autoplay = attributes.autoplay,
        show_pag = attributes.show_pag,
        show_nav = attributes.show_nav,
        show_text = attributes.show_text,
        autoplay_speed = attributes.autoplay_speed,
        pag_bg_color = attributes.pag_bg_color,
        pag_color = attributes.pag_color,
        text_bg_color = attributes.text_bg_color,
        text_color = attributes.text_color,
        text_align = attributes.text_align,
        text_size = attributes.text_size,
        text_font = attributes.text_font,
        slider_height = attributes.slider_height,
        autostop = attributes.autostop,
        items = attributes.items,
        main_text_size = attributes.main_text_size;


    if ((0, _utils.SliderBerg_isset)(attributes, 'text_font')) {
      (0, _utils.SliderBerg_GoogleFontLoader)(text_font);
    }

    render(React.createElement(_slider.SliderBerg_Slider, {
      options: {
        slide_timeout: autoplay_speed * 1000,
        autoplay: autoplay,
        show_nav: show_nav,
        show_pag: show_pag,
        show_text: show_text,
        pag_bg_color: pag_bg_color,
        pag_color: pag_color,
        text_bg_color: text_bg_color,
        text_color: text_color,
        text_align: text_align,
        slider_height: slider_height,
        autostop: autostop,
        text_size: text_size,
        text_font: text_font,
        main_text_size: main_text_size
      },
      items: items,
      where: 'frontend'
    }), sliders[i]);

    console.log('%c players present on page and running...', 'color: #9C27B0');
  }
});

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// frontend/frontend.build.js